/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIMeasurement
 */
export interface APIMeasurement {
    /**
     * 
     * @type {string}
     * @memberof APIMeasurement
     */
    unit: string;
    /**
     * 
     * @type {string}
     * @memberof APIMeasurement
     */
    value: string;
}

/**
 * Check if a given object implements the APIMeasurement interface.
 */
export function instanceOfAPIMeasurement(value: object): value is APIMeasurement {
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function APIMeasurementFromJSON(json: any): APIMeasurement {
    return APIMeasurementFromJSONTyped(json, false);
}

export function APIMeasurementFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIMeasurement {
    if (json == null) {
        return json;
    }
    return {
        
        'unit': json['unit'],
        'value': json['value'],
    };
}

export function APIMeasurementToJSON(value?: APIMeasurement | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'unit': value['unit'],
        'value': value['value'],
    };
}

